const Clock = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5_7859)">
        <circle cx="12" cy="12" r="12" fill="#93A8B3" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18ZM12.6665 9.33317C12.6665 8.96498 12.368 8.6665 11.9998 8.6665C11.6316 8.6665 11.3332 8.96498 11.3332 9.33317V11.6637L9.84541 12.018C9.48724 12.1032 9.26601 12.4627 9.35129 12.8209C9.43657 13.1791 9.79606 13.4003 10.1542 13.315L12.1542 12.8389C12.4546 12.7673 12.6665 12.499 12.6665 12.1903V9.33317Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_5_7859">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Clock;
